import App from "@/App";
import "./index.css";

// After
import { createRoot } from "react-dom/client";

import { initTheme } from "@/hooks/theme";

initTheme();
const container = document.getElementById("root");
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(<App />);

// Register the (cache-free) service worker so the app is an installable PWA.
// Dev is served over http on localhost where SWs are allowed; skip it there to
// avoid interfering with Vite HMR.
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // A failed registration must never break the app.
    });
  });
}
